// extracted by mini-css-extract-plugin
module.exports = {"box":"BoxItem_box__2IgbY","highlighted":"BoxItem_highlighted__4NrN0","boxContainer":"BoxItem_boxContainer__G32_T","header":"BoxItem_header__NH2Yg","main":"BoxItem_main__chLHB"};